var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card uf-card" }, [
    _c("div", { staticClass: "card-head" }, [
      _c("div", [
        _c("h3", [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.ufTitle"))),
        ]),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("collectionOperationDashboard.ufDesc"))),
        ]),
      ]),
    ]),
    _c("div", { ref: "ufChart", staticClass: "chart tall" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }